import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const ITEMS = [
    { q: "Is this a replacement for my current physician?", a: "No — we work in parallel with your existing care team. Dr. Hanspal’s practice focuses on long-arc, lifestyle-led reversal and longevity, and we coordinate with your specialists when relevant." },
    { q: "How does the hybrid model actually work?", a: "You begin with a deep, in-clinic or virtual baseline. Follow-ups, recalibrations and continuity are delivered virtually — with periodic in-clinic check-ins in Chennai or Gurugram when clinically warranted." },
    { q: "Which conditions are typically reversed?", a: "PCOS, prediabetes, type 2 diabetes, fatty liver, mild-to-moderate hypertension, and dyslipidaemia are common reversal targets. Reversal here means restoring biomarkers to normative ranges while tapering medication under supervision when appropriate." },
    { q: "What does the longevity pathway include?", a: "Comprehensive biomarker panels (including ApoB, hsCRP, fasting insulin, hormones, micronutrients), VO₂max and strength benchmarking, sleep and circadian assessment, and an executable 12-week protocol with continuous tracking." },
    { q: "Do I need to share wearable data?", a: "It’s helpful but optional. If you use Oura, a CGM, Whoop, Apple Watch or Garmin, we can incorporate those signals to refine your protocol. If you don’t, we’ll suggest the minimum useful set." },
    { q: "How long is the commitment?", a: "Reversal protocols are typically a 12-week intensive followed by quarterly review. Longevity engagements are designed as annual partnerships." },
];

export default function FAQPreview({ limit }) {
    const items = typeof limit === "number" ? ITEMS.slice(0, limit) : ITEMS;
    const [open, setOpen] = useState(0);

    return (
        <section style={{ backgroundColor: "hsl(var(--bg-chalk))" }}>
            <div className="ihx-container py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
                <div className="lg:col-span-4">
                    <span className="ihx-eyebrow">Questions, answered</span>
                    <h2 className="ihx-h-section mt-5">
                        The honest questions patients usually ask <span className="ihx-italic">first.</span>
                    </h2>
                    <p className="ihx-lead mt-6 max-w-md">
                        If something below doesn’t answer your concern, the Discovery
                        Form is designed to capture it — and Dr. Hanspal’s team will reply
                        personally.
                    </p>
                </div>

                <div className="lg:col-span-8">
                    <div className="border-t border-[hsl(var(--border-stone))]">
                        {items.map((it, idx) => {
                            const isOpen = open === idx;
                            return (
                                <div key={it.q} className="border-b border-[hsl(var(--border-stone))]">
                                    <button
                                        type="button"
                                        onClick={() => setOpen(isOpen ? -1 : idx)}
                                        aria-expanded={isOpen}
                                        className="w-full text-left flex items-start gap-6 py-5 group"
                                    >
                                        <span className="font-serif text-[20px] md:text-[24px] text-[hsl(var(--brand-ink-deep))] leading-snug flex-1 tracking-[-0.01em]">
                                            {it.q}
                                        </span>
                                        <span
                                            className="mt-1 shrink-0 w-9 h-9 rounded-full grid place-items-center border border-[hsl(var(--border-stone))] group-hover:border-[hsl(var(--brand-ink-deep))] group-hover:bg-[hsl(var(--brand-ink-deep))] group-hover:text-[hsl(var(--bg-chalk))] transition-colors duration-300"
                                            aria-hidden
                                        >
                                            {isOpen ? <Minus size={16} strokeWidth={1.6} /> : <Plus size={16} strokeWidth={1.6} />}
                                        </span>
                                    </button>
                                    <div
                                        className="grid transition-[grid-template-rows] duration-300 ease-in-out"
                                        style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                                    >
                                        <div className="overflow-hidden">
                                            <p className="text-[15px] leading-[1.75] text-[hsl(var(--ink-soft))] pb-6 pr-12 max-w-2xl">
                                                {it.a}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
